import { reactOnCms } from 'common/js/react_on_cms';
import BookingExpiry from 'components/booking_expiry';
import Cart from 'tenants/cccsyd/checkout_flow/cart';

reactOnCms.register({
  Cart,
  BookingExpiry,
});
